import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MessageService } from '../services/message.service';

@Injectable()
export class SuperAdminGuard  {

  constructor(private messageService: MessageService, public router: Router, public http: HttpClient) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.http.get('/Users/AuthedUser').toPromise().then((res: any) => {
        switch (res?.Role) {// there can only be one role
          case "citipostsuperadmin":
            return true;
          default:
            this.messageService.emitChange({ "Css": "error", "Message": "Auth Oops... access denied..." });
            this.router.navigate(['/denied']);
            return true;
        }
    });  
  }

}

